"use strict";
import React from "react";
import Api from "../api/api";
import "../services/api_service";
import BouncesMessage from "./bounces_message";
import DisablingButton from "./disabling_button";
import EmailTypeAhead from "./email_typeahead";
import { emailService } from "../services/email_service";
import { Flash } from "../components/flash";
import OutgoingEmailSignature from "../helpers/outgoing_email_signature";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
var EmailForwarderMixin = {
  forwardingCanceled: function() {
    this.setState({ forwardingEmail: false });
  },
  forwardingDone: function(completed) {
    this.forwardingCanceled();
    if (completed) {
      ToDashboardWithFilters(this.props.location, this.history);
    }
  },
  forwardEmail: function() {
    this.setState({ forwardingEmail: true });
  },
  possibleEmailForwarder: function(email) {
    if (this.state.forwardingEmail) {
      return /* @__PURE__ */ React.createElement(
        EmailForwarder,
        {
          email,
          onCancel: this.forwardingCanceled,
          onDone: this.forwardingDone
        }
      );
    }
  }
};
var EmailForwarder = React.createClass({
  getInitialState: function() {
    return {
      mark_complete: false,
      note: OutgoingEmailSignature.signatureWithBuffer(),
      add_as_contacts: false,
      contactEmails: [],
      recipients: []
    };
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "EmailForwarder",
        className: "modal__medium-container email-forwarder"
      },
      /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement(BouncesMessage, { recipients: this.state.recipients }), /* @__PURE__ */ React.createElement("label", null, "Recipients"), /* @__PURE__ */ React.createElement(
        EmailTypeAhead,
        {
          focusBehavior: "focus",
          onChange: this.recipientsChanged
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "small-12 column email-forwarder__checkboxes" }, /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: this.state.mark_complete || false,
          onChange: (e) => this.setState({
            mark_complete: e.target.checked
          })
        }
      ), /* @__PURE__ */ React.createElement("span", null, "\xA0Ignore this invoice and remove it from the dashboard.")), /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: this.state.add_as_contacts || false,
          onChange: (e) => this.setState({
            add_as_contacts: e.target.checked
          })
        }
      ), /* @__PURE__ */ React.createElement("span", null, "\xA0Save new email addresses as contacts")), /* @__PURE__ */ React.createElement("label", null, "Note"), /* @__PURE__ */ React.createElement(
        "textarea",
        {
          rows: 5,
          value: this.state.note || "",
          onChange: (e) => this.setState({ note: e.target.value })
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          className: "button--confirmation",
          disabled: this.state.forwarding || !Array.isArray(this.state.recipients) || this.state.recipients.length === 0,
          disabledText: this.state.forwarding ? "Forwarding..." : "Enter Recipients to Forward Email",
          onClick: this.forward
        },
        "Forward Email"
      ), /* @__PURE__ */ React.createElement("span", { className: "button--cancel-wrapper" }, /* @__PURE__ */ React.createElement("span", null, "or"), /* @__PURE__ */ React.createElement("button", { onClick: this.props.onCancel, className: "button--cancel" }, "cancel"))))
    );
  },
  recipientsChanged: function(recipients, bounces) {
    this.setState({
      recipients
    });
  },
  forward: function() {
    this.setState({ forwarding: true });
    Api.Email.forward({
      ids: [this.props.email.id],
      recipients: this.state.recipients.join(),
      complete: this.state.mark_complete,
      note: this.state.note,
      add_as_contacts: this.state.add_as_contacts
    }).then(
      (data) => {
        emailService.updateFromData(data);
        Flash.success("Hurray, the email is on its way!");
        this.props.onDone(this.state.mark_complete);
      },
      (error) => {
        this.setState({ forwarding: false });
        return error;
      }
    );
  }
});
export { EmailForwarder, EmailForwarderMixin };
